/*
 * Purpose : Common component for Alert modal at the time of delete
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap'
import {IoMdAlert} from "react-icons/io"

const DeleteAlertModal = (props) => {
    return (
            <Modal isOpen={props.open} toggle={()=>props.handler(false)}>
                <ModalBody>
                    <div style={{display:"flex", justifyContent:"space-evenly"}}>
                        <IoMdAlert style={{fontSize:"50px",color:"#dc3545"}}/>
                        <div>
                            <h6>Are you sure you want to delete this record?</h6>
                            <p>You can't undo this action.</p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                            style={{backgroundColor:"#dc3545", borderColor:"#c82333", boxShadow:"0px 1px 2px 2px #C0C0C0"}} onClick={()=> props.deleteHandler()}>Delete</Button>{' '}
                    <Button color="secondary" onClick={()=>props.handler(false)}>Cancel</Button>    
                </ModalFooter>
            </Modal>
    )
}

export default DeleteAlertModal;